import React from 'react';
import { Button, RobbieMark } from '../../ui';

/**
 * What the welcome collapses to once dismissed: one line carrying the same
 * action. It stays until the person actually has an RFQ of their own, which
 * is also what removes the old grey "you have no active RFQs" line from the
 * table — a dead end replaced by the way out of it.
 */
export interface WelcomeStripProps {
  onStart: () => void;
  /** Re-opens the full welcome for this session only; the dismissal stands. */
  onExpand: () => void;
}

export const WelcomeStrip: React.FC<WelcomeStripProps> = ({ onStart, onExpand }) => (
  <section className="flex flex-wrap items-center gap-s4 rounded-card border border-robbie-border bg-ai-panel px-s6 py-s4">
    <RobbieMark size="sm" aria-label="Robbie" />
    <span className="min-w-[220px] flex-1 text-[13px] leading-[1.5] text-ink-secondary">
      <span className="font-semibold text-ink">Five stages, BOM to award</span> — I do the work, you
      approve each step.
    </span>
    <Button variant="ghost" size="sm" onClick={onExpand}>How I work</Button>
    <Button size="sm" onClick={onStart}>Start your first RFQ</Button>
  </section>
);

export default WelcomeStrip;
